import { EngageLibraryItemTypeEnum, PendingMembershipChange } from './engage-library-types';
import { EngageLibraryChangeGroup } from './EngageLibraryChangeGroup';
import styles from './EngageLibraryChangeSection.module.css';

const TYPE_GROUPS = [
  { type: EngageLibraryItemTypeEnum.AUTOMATION, label: 'Automations' },
  { type: EngageLibraryItemTypeEnum.SEGMENT, label: 'Segments' },
];

interface EngageLibraryChangeSectionProps {
  title: string;
  changes: PendingMembershipChange[];
}

export function EngageLibraryChangeSection({ title, changes }: EngageLibraryChangeSectionProps) {
  const heading = `${title} (${changes.length})`;
  const groups = TYPE_GROUPS.map(group => ({
    ...group,
    changes: changes.filter(change => change.row.type === group.type),
  })).filter(group => group.changes.length > 0);

  return (
    <section className={styles.section}>
      <h3>{heading}</h3>
      {groups.map(group => (
        <EngageLibraryChangeGroup key={group.type} label={group.label} changes={group.changes} />
      ))}
    </section>
  );
}
